module.exports = __webpack_public_path__ + "img/客服码.efe0eb4b.png";